"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowNumericEditor_1 = require("../../../../../../../shared/components/editors/CardRowNumericEditor");
var PlayerLevelBetAmountsEditor = /** @class */ (function (_super) {
    __extends(PlayerLevelBetAmountsEditor, _super);
    function PlayerLevelBetAmountsEditor(props) {
        return _super.call(this, props) || this;
    }
    PlayerLevelBetAmountsEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.setState({
            app_currency_id: 0,
            app_currency_title: "",
            min_total_bet_amount: 0,
            points_exchange_money_price: 100,
            points_exchange_min_amount: 100,
            cashback_bonus_percent_x100: 10,
            cashback_bonus_wager: 30,
            birthday_bonus_wager: 30,
            birthday_bonus_amount: 1000,
            level_access_bonus_wager: 30,
            level_access_bonus_amount: 1000
        }, function () {
            if (_this.props.record) {
                var _item = _this.props.data.getById(_this.props.record.key);
                if (_item) {
                    _this.setState({
                        app_currency_id: _item.app_currency_id,
                        app_currency_title: _item.app_currency_title,
                        min_total_bet_amount: _item.min_bet_amount,
                        points_exchange_money_price: _item.points_exchange_money_price,
                        points_exchange_min_amount: _item.points_exchange_min_amount,
                        cashback_bonus_percent_x100: _item.cashback_bonus_percent_x100,
                        cashback_bonus_wager: _item.cashback_bonus_wager,
                        birthday_bonus_wager: _item.birthday_bonus_wager,
                        birthday_bonus_amount: _item.birthday_bonus_amount,
                        level_access_bonus_wager: _item.level_access_bonus_wager,
                        level_access_bonus_amount: _item.level_access_bonus_amount
                    });
                }
            }
        });
        this.doReSetRules();
    };
    PlayerLevelBetAmountsEditor.prototype.doReSetRules = function () {
        this.setState({
            app_currency_rules: { isError: false },
            min_total_bet_amount_rules: { isError: false },
            points_exchange_money_price_rules: { isError: false },
            points_exchange_min_amount_rules: { isError: false },
            cashback_bonus_percent_x100_rules: { isError: false },
            cashback_bonus_wager_rules: { isError: false },
            birthday_bonus_wager_rules: { isError: false },
            birthday_bonus_amount_rules: { isError: false },
            level_access_bonus_wager_rules: { isError: false },
            level_access_bonus_amount_rules: { isError: false },
        });
    };
    PlayerLevelBetAmountsEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.app_currency_id <= 0) || (this.state.app_currency_title.length === 0)) {
            this.setState({ app_currency_rules: { isError: true, errorMessage: "Валюта не выбрана!" } });
            return false;
        }
        if (this.state.min_total_bet_amount < 0) {
            this.setState({ min_total_bet_amount_rules: { isError: true, errorMessage: "Минимальная ставка не заполнена !" } });
            return false;
        }
        if (this.state.points_exchange_money_price < 1) {
            this.setState({ points_exchange_money_price_rules: { isError: true, errorMessage: "Курс обмена некорректен !" } });
            return false;
        }
        if (this.state.points_exchange_min_amount < 1) {
            this.setState({ points_exchange_min_amount_rules: { isError: true, errorMessage: "Минимальная сумма некорректна !" } });
            return false;
        }
        if ((this.state.cashback_bonus_percent_x100 < 1) || (this.state.cashback_bonus_percent_x100 > 100)) {
            this.setState({ cashback_bonus_percent_x100_rules: { isError: true, errorMessage: "Процент отчислений в кэшбек задан некорректно !" } });
            return false;
        }
        if (this.state.cashback_bonus_wager < 1) {
            this.setState({ cashback_bonus_wager_rules: { isError: true, errorMessage: "Значение вейджекра кэшбека задано некорректно !" } });
            return false;
        }
        if (this.state.birthday_bonus_amount < 0) {
            this.setState({ birthday_bonus_amount_rules: { isError: true, errorMessage: "Значение суммы бонуса на день рождения некорректна !" } });
            return false;
        }
        if (this.state.birthday_bonus_wager < 0) {
            this.setState({ birthday_bonus_wager_rules: { isError: true, errorMessage: "Значение вейджекра бонуса на день рождения задано некорректно !" } });
            return false;
        }
        if (this.state.level_access_bonus_amount < 0) {
            this.setState({ level_access_bonus_amount_rules: { isError: true, errorMessage: "Значение суммы бонуса за достижение уровня некорректно !" } });
            return false;
        }
        if (this.state.level_access_bonus_wager < 0) {
            this.setState({ level_access_bonus_wager_rules: { isError: true, errorMessage: "Значение вейджекра бонуса за достижение уровня задано некорректно !" } });
            return false;
        }
        return true;
    };
    PlayerLevelBetAmountsEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                min_total_bet_amount: this.state.min_total_bet_amount,
                points_exchange_money_price: this.state.points_exchange_money_price,
                points_exchange_min_amount: this.state.points_exchange_min_amount,
                cashback_bonus_percent_x100: this.state.cashback_bonus_percent_x100,
                cashback_bonus_wager: this.state.cashback_bonus_wager,
                birthday_bonus_wager: this.state.birthday_bonus_wager,
                birthday_bonus_amount: this.state.birthday_bonus_amount,
                level_access_bonus_wager: this.state.level_access_bonus_wager,
                level_access_bonus_amount: this.state.level_access_bonus_amount
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Параметры ставок для уровня изменены!");
            });
        }
    };
    PlayerLevelBetAmountsEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                brand_bonus_level_id: this.props.rootRecord.key,
                app_currency_id: this.state.app_currency_id,
                min_total_bet_amount: this.state.min_total_bet_amount,
                points_exchange_money_price: this.state.points_exchange_money_price,
                points_exchange_min_amount: this.state.points_exchange_min_amount,
                cashback_bonus_percent_x100: this.state.cashback_bonus_percent_x100,
                cashback_bonus_wager: this.state.cashback_bonus_wager,
                birthday_bonus_wager: this.state.birthday_bonus_wager,
                birthday_bonus_amount: this.state.birthday_bonus_amount,
                level_access_bonus_wager: this.state.level_access_bonus_wager,
                level_access_bonus_amount: this.state.level_access_bonus_amount
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Параметры ставок для уровня добавлены!");
            });
        }
    };
    PlayerLevelBetAmountsEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    PlayerLevelBetAmountsEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Новые параметры суммы ставок";
        }
        else {
            return "Изменить параметры суммы ставок";
        }
    };
    PlayerLevelBetAmountsEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 720 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Валюта:", placeholder: "Выберите валюту" }, value: { key: this.state.app_currency_id, value: this.state.app_currency_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_currency_id: newVal.key,
                        app_currency_title: newVal.value,
                        app_currency_rules: { isError: false },
                    });
                }, items: this.props.availCurrency, required: true, rules: this.state.app_currency_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Мин сумма ставок:", placeholder: "Введите минимальную сумму ставок" }, values: { max: 9999999999, min: 0, value: this.state.min_total_bet_amount }, onValueChanged: function (newVal) {
                    _this.setState({
                        min_total_bet_amount: newVal,
                        min_total_bet_amount_rules: { isError: false }
                    });
                }, required: true, rules: this.state.min_total_bet_amount_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Курс обмена пойнтов:", placeholder: "Введите курс обмена пойнтов" }, values: { max: 9999999999, min: 1, value: this.state.points_exchange_money_price }, onValueChanged: function (newVal) {
                    _this.setState({
                        points_exchange_money_price: newVal,
                        points_exchange_money_price_rules: { isError: false }
                    });
                }, precision: 2, required: true, rules: this.state.points_exchange_money_price_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Мин сумма обмена:", placeholder: "Введите минимальную сумму пойнтов для обмена" }, values: { max: 9999999999, min: 1, value: this.state.points_exchange_min_amount }, onValueChanged: function (newVal) {
                    _this.setState({
                        points_exchange_min_amount: newVal,
                        points_exchange_min_amount_rules: { isError: false }
                    });
                }, precision: 2, required: true, rules: this.state.points_exchange_min_amount_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Процент кэшбэка:", placeholder: "Введите значение процента кэшбэка" }, values: { max: 100, min: 0, value: this.state.cashback_bonus_percent_x100 }, onValueChanged: function (newVal) {
                    _this.setState({
                        cashback_bonus_percent_x100: newVal,
                        cashback_bonus_percent_x100_rules: { isError: false }
                    });
                }, required: true, rules: this.state.cashback_bonus_percent_x100_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Вейджер кэшбека:", placeholder: "Введите значение вейджера кэшбека" }, values: { max: 1000, min: 0, value: this.state.cashback_bonus_wager }, onValueChanged: function (newVal) {
                    _this.setState({
                        cashback_bonus_wager: newVal,
                        cashback_bonus_wager_rules: { isError: false }
                    });
                }, required: true, rules: this.state.cashback_bonus_wager_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Сумма бонуса на ДР:", placeholder: "Введите значение суммы бонуса на день рождения" }, values: { max: 9999999, min: 0, value: this.state.birthday_bonus_amount }, onValueChanged: function (newVal) {
                    _this.setState({
                        birthday_bonus_amount: newVal,
                        birthday_bonus_amount_rules: { isError: false }
                    });
                }, required: true, rules: this.state.birthday_bonus_amount_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Вейджер бонуса на ДР:", placeholder: "Введите значение вейджера бонуса на день рождения" }, values: { max: 1000, min: 0, value: this.state.birthday_bonus_wager }, onValueChanged: function (newVal) {
                    _this.setState({
                        birthday_bonus_wager: newVal,
                        birthday_bonus_wager_rules: { isError: false }
                    });
                }, required: true, rules: this.state.birthday_bonus_wager_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Сумма бонуса за уровень:", placeholder: "Введите значение суммы бонуса за уровень" }, values: { max: 9999999, min: 0, value: this.state.level_access_bonus_amount }, onValueChanged: function (newVal) {
                    _this.setState({
                        level_access_bonus_amount: newVal,
                        level_access_bonus_amount_rules: { isError: false }
                    });
                }, required: true, rules: this.state.level_access_bonus_amount_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Вейджер бонуса за уровень:", placeholder: "Введите бонуса за уровень" }, values: { max: 1000, min: 0, value: this.state.level_access_bonus_wager }, onValueChanged: function (newVal) {
                    _this.setState({
                        level_access_bonus_wager: newVal,
                        level_access_bonus_wager_rules: { isError: false }
                    });
                }, required: true, rules: this.state.level_access_bonus_wager_rules }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return PlayerLevelBetAmountsEditor;
}(React.Component));
exports.default = PlayerLevelBetAmountsEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_player_levels/ui/component/cfg_betamounts/PlayerLevelBetAmountsEditor.tsx
// module id = 1955
// module chunks = 0